module.exports = __webpack_public_path__ + "img/container.bc0df874.jpg";